var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9598 5.37684C48.6783 4.33944 48.1292 3.39369 47.3672 2.63376C46.6052 1.87382 45.6568 1.32623 44.6166 1.04552C40.8083 0.00976562 25.481 0.00976562 25.481 0.00976562C25.481 0.00976562 10.1536 0.041152 6.34537 1.0769C5.30511 1.35762 4.35674 1.90521 3.59471 2.66514C2.83268 3.42507 2.28358 4.37083 2.00209 5.40823C0.850178 12.1563 0.403261 22.4385 2.03356 28.9166C2.31505 29.954 2.86416 30.8998 3.62618 31.6597C4.38821 32.4197 5.33658 32.9673 6.37684 33.248C10.1851 34.2837 25.5124 34.2837 25.5124 34.2837C25.5124 34.2837 40.8398 34.2837 44.648 33.248C45.6883 32.9673 46.6367 32.4197 47.3987 31.6597C48.1607 30.8998 48.7098 29.954 48.9913 28.9166C50.2062 22.1592 50.5807 11.8832 48.9598 5.37684Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5938 24.4896L33.3089 17.1452L20.5938 9.80078V24.4896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.a355143a7e36eee6d1875e7aba89c431.svg";
export { ForwardRef as ReactComponent };